const configList = {
  // h5分享页面信息
  sharePage: `/v1/UserFissionNew/sharePage`,
  // 邀请赚钱页面信息
  invitePage: `/v1/UserFissionNew/invitePage`,
  // 主页数据
  homePage: `/v1/userFission/homePage`,
  // 攻略详情
  raidersDetails: `/v1/UserFissionNew/raidersDetails`,
  // 我的收益
  myIncome: `/v1/UserFissionNew/myIncome`,
  // 邀请明细列表
  inviteDetails: `/v1/UserFissionNew/inviteDetails`,
  // 奖励明细列表
  rewardDetails: `/v1/UserFissionNew/rewardDetails`,
  // 余额明细列表
  balanceDetails: `/v1/UserFissionNew/balanceDetails`,
  // 分享海报图信息
  genSharePosters: `/v1/userFission/genSharePosters`,
};

export default (baseApi: string) => {
  const obj = {};
  for (const key of Object.keys(configList)) {
    obj[key] = `${baseApi}${configList[key]}`;
  }
  return obj;
};
